import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const STORAGE_KEY = "msq_admin_token";

export const adminApi = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: { "Content-Type": "application/json" },
});

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(STORAGE_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

adminApi.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    if (status === 401) {
      localStorage.removeItem(STORAGE_KEY);
      if (typeof window !== "undefined" && !window.location.pathname.endsWith("/admin/login")) {
        window.location.replace("/admin/login");
      }
    }
    return Promise.reject(error);
  }
);

export const tokenStore = {
  get: () => localStorage.getItem(STORAGE_KEY),
  set: (t) => localStorage.setItem(STORAGE_KEY, t),
  clear: () => localStorage.removeItem(STORAGE_KEY),
};

export async function adminLogin(email, password) {
  const { data } = await adminApi.post("/admin/auth/login", { email, password });
  tokenStore.set(data.access_token);
  return data;
}

export async function adminMe() {
  const { data } = await adminApi.get("/admin/auth/me");
  return data;
}
